import React, { useMemo, useState } from "react";
import SelectComponent from "@ui/components/Select/Select.component";
import SwitchComponent from "@ui/features/Device-settings/Switch.component";
import ModalComponent from "@ui/components/Modal/Modal.component";
import ButtonComponent from "@ui/components/Button/Button.component";
import ButtonBarComponent from "@ui/components/Button-bar/Button-bar.component";
import ModalFormComponent from "@ui/components/Modal-form/Modal-form.component";
import useDictionary from "@ui/hooks/useDictionary";
import { IProps } from "./IProps";
import DeviceSelectionTable from "./Device-selection-table";
import { TextField } from "@mui/material";
import SearchField from "@ui/components/Search-field/SearchField";

const Component: React.FC<IProps> = ({
    lang,
    selectedSubuser,
    devicesList,
    serverError,
    loading,
    onAddClick,
    onBtnKeyDown,
    onCancelClick,
    onStateChange,
}: IProps) => {
    const [search, setSearch] = useState("");

    const filtredDeviceList = useMemo(
        () =>
            devicesList.filter((device) => {
                const isMatch =
                    device.label
                        .toString()
                        .toLocaleLowerCase()
                        .includes(search.toLocaleLowerCase()) ||
                    device.value
                        .toString()
                        .toLocaleLowerCase()
                        .includes(search.toLocaleLowerCase());

                return isMatch;
            }),
        [search]
    );

    const getWord = useDictionary();

    return (
        <ModalComponent
            className="add-device-to-subuser"
            title={`${getWord("addDeviceToSubuserTitle")} "${selectedSubuser}"`}
            alertText={serverError ? "serverError" : ""}
            lang={lang}
            loading={loading}
            onBtnKeyDown={onBtnKeyDown}
            onClose={onCancelClick}
        >
            <div style={{ marginBottom: 10 }} className="modal__form">
                <SearchField search={search} onSearch={setSearch} />
            </div>
            <ModalFormComponent>
                <DeviceSelectionTable
                    values={filtredDeviceList}
                    onStateChange={onStateChange}
                />
            </ModalFormComponent>
            <ButtonBarComponent>
                <ButtonComponent
                    label="add"
                    lang={lang}
                    onClick={onAddClick}
                    onKeyDown={onBtnKeyDown}
                />
                <ButtonComponent
                    color="error"
                    label="cancel"
                    lang={lang}
                    onClick={onCancelClick}
                    onKeyDown={onBtnKeyDown}
                />
            </ButtonBarComponent>
        </ModalComponent>
    );
};

const AddDeviceToSubuserComponent = React.memo(Component);

export default AddDeviceToSubuserComponent;
